import {
  BusinessCollectionCompType,
  IObjektVy,
} from '../../../../../Types/ObjektVy';

export const collectionCompToObjektVy = (
  comp: BusinessCollectionCompType,
  id: string = 'standard'
): IObjektVy => ({
  id: id,
  type: 'ObjektVy',
  info: {},
  def: _ => ({ caption: 'caption', comp: comp }),
});
